import { Trophy } from 'lucide-react';


const TestimonialsSectionV2 = () => {
  const stories = [
    {
      type: "startup",
      company: "Cofrsh",
      industry: "Cafteria and Hospitality",
      quote: "They played an important role in transforming our business to digital first from offline. They built great customer facing as well as internal tools.",
      metrics: { time: "6 months", users: "10K users" },
      person: "",
      gradient: "from-blue-500 to-indigo-600"
    },
    {
      type: "startup",
      company: "Neopay",
      industry: "Digital Payments & FMCG",
      quote: "They delivered our complete digital platform - 3 mobile apps, a comprehensive dashboard, and end-to-end backend solutions. Their full-stack expertise transformed our vision into reality.",
      metrics: { delivery: "3 mobile apps", platform: "Full dashboard", scope: "End-to-end" },
      person: "",
      gradient: "from-purple-500 to-pink-600"
    },
    {
      type: "startup",
      company: "Battgenie",
      industry: "Battery Technology",
      quote: "They built our complete web platform and developed robust internal tools that streamlined our operations. Their deployment expertise ensured everything ran smoothly from day one.",
      metrics: { websites: "Full platform", tools: "Internal systems", deployment: "Production ready" },
      person: "",
      gradient: "from-green-500 to-emerald-600"
    }
  ];


  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-purple-100 text-purple-600 text-sm font-semibold mb-6">
            <Trophy className="w-4 h-4" />
            Success Stories
          </span>
          <h2 className="text-2xl md:text-5xl font-bold mb-4 text-gray-900">
            150+ Businesses Transformed
          </h2>
          <p className="md:text-xl text-gray-600">
            From pre-seed startups to established SMEs, we've helped them all succeed
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {stories.map((story, index) => (
            <div key={index} className="group h-full">
              <div className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border border-gray-100 h-full flex flex-col">
                <div className={`h-2 bg-gradient-to-r ${story.gradient}`}></div>
                <div className="p-8 flex flex-col flex-grow">
                  <div className="flex items-center justify-between mb-4">
                    <div>
                      <h3 className="font-bold text-xl text-gray-900">{story.company}</h3>
                      <p className="text-sm text-gray-500">{story.industry}</p>
                    </div>
                    <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
                      story.type === 'startup'
                        ? 'bg-blue-100 text-blue-600'
                        : 'bg-purple-100 text-purple-600'
                    }`}>
                      {story.type === 'startup' ? 'Startup' : 'SME'}
                    </span>
                  </div>

                  <blockquote className="text-gray-700 mb-6 italic">
                    "{story.quote}"
                  </blockquote>

                  <div className="space-y-2 mb-6">
                    {Object.entries(story.metrics).map(([key, value]) => (
                      <div key={key} className="flex items-center justify-between text-sm">
                        <span className="text-gray-500 capitalize">{key}:</span>
                        <span className="font-bold text-gray-900">{value}</span>
                      </div>
                    ))}
                  </div>

                  <div className="pt-6 border-t border-gray-100 mt-auto">
                    <p className="text-sm font-semibold text-gray-700">{story.person}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSectionV2;
